import moment from "moment";
import * as yup from "yup";
import { DOCUMENTS, IS_EDITABLE, LABEL, REQUIRED, _URL } from "../../../constants/forms";

export const REQUIRED_DOC = ["Approval Letters", "Recommendation letter"]
export const project = {
  _id:"",
  documents:[
    {
      label: REQUIRED_DOC[0],
      required: false,
      url: "",
      isEditable: false,
      isInputOpened: false,
    },
    {
      label: REQUIRED_DOC[1],
      required: false,
      url: "",
      isEditable: false,
      isInputOpened: false,
    }
  ]
}
export const meetingInitalData = {
  _id: '',
  meetingId: "",
  meetingDate: moment().format("yyyy-MM-DD"),
  meetingType: '',
  lastSubmissionDate: moment().format("yyyy-MM-DD"),
  agenda: "",
  mom: "",
  selectedMeeting: "",
  projects:[{
    ...project,
    documents: [
        ...project.documents
    ]
    }],
};

export const meetingDetailsSchema = yup.object().shape({
  meetingId: yup.string().required("Meeting Id is required"),
  meetingDate: yup.date().required("Meeting Date is required"),
  lastSubmissionDate: yup.date().required("Meeting last Submission Date is required"),
  agenda: yup.string().required("Meeting agenda is required"),
});

export const meetingScheduleValidationSchema = yup.object().shape({
  meetingId: yup.string().required("Meeting Id is required"),
  meetingDate: yup.date().required("Meeting Date is required"),
  lastSubmissionDate: yup.date().required("Meeting last Submission Date is required"),
  agenda: yup.string().required("Meeting agenda is required"),
  projects: yup.array().of(
    yup.object().shape({
      _id: yup.object().shape({
        label: yup.string().required('Select a project'),
        value: yup.string(),
      }).required('Select a project'),
      [DOCUMENTS]: yup
        .array()
        .of(
          yup.object().shape({
            [LABEL]: yup.string().required("Label is required"),
            [REQUIRED]: yup.boolean().required(),
            [_URL]: yup.string().when('isDeletable', {
              is: true,
              then: yup.string().test(_URL, function (value) {
                const label = this.parent[LABEL] || "";
                return (
                  Boolean(value) ||
                  this.createError({ message: `Please add ${label} document` })
                );
              }),
              otherwise: yup.string(),
            }),
          })
        )
        .required("At least one document is required")
        .min(1),
    })
  ),
});